import * as React from "react";
import styled from "styled-components";
import { useLocation } from "@reach/router";
import FreeTrialForm from "../form/free-trial/free-trial";
import { StaticImage } from "gatsby-plugin-image";
import { Body1CSS } from "../typography/typography";
import Link from "../link/link";
import CopyScapeButton from "../button/copyscape/copyscape";
import HiddenEmailForm from "../form/email/hidden-email-form";

const Root = styled.footer`
  ${Body1CSS}
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.emperor};
  color: ${({ theme }) => theme.colors.day};
  padding: 20px;
  gap: 40px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.up("desktop")} {
    flex-direction: row;
  }
`;

const Column = styled.div`
  display: flex;
  max-width: ${({ $maxWidth }) =>
    $maxWidth !== undefined ? `${$maxWidth}px` : undefined};
  flex-direction: column;
  a {
    color: ${({ theme }) => theme.colors.day};
    text-decoration: none;
  }
  gap: 10px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  ${({ theme }) => theme.breakpoints.up("desktop")} {
    flex-direction: row;
  }
`;

const Title = styled.span`
  font-weight: 500;
`;

const Divider = styled.div`
  height: 2px;
  width: 100%;
  background-color: white;
`;

const FooterLink = styled(Link)`
  color: white;
  font-size: 15;
  text-decoration: underline;
`;

function FooterBase(props) {
  const { email, items } = props;
  const location = useLocation();

  return (
    <Root>
      {location.pathname !== "/products/free-trial/" ? (
        <FreeTrialForm hidden />
      ) : null}
      <HiddenEmailForm />
      <Content>
        <Column $maxWidth={200}>
          <StaticImage
            src="../../assets/images/vorne-logo-white.svg"
            alt="logo"
            objectFit="contain"
            objectPosition="0"
          />
          <a href="tel:+1.630.875.3600">+1.630.875.3600</a>
          <a href={`mailto:${email}`}>{email}</a>
          <span>1445 Industrial Dr. Itasca, IL 60143</span>
        </Column>
        {items.map((item) => (
          <Column key={item.title}>
            <Title>{item.title}</Title>
            <Divider />
            <Row>
              {item.categories.map((item, idx) => (
                <Column key={idx}>
                  {item.items.map((item) => (
                    <Link key={item.text} url={item.url}>
                      {item.text}
                    </Link>
                  ))}
                </Column>
              ))}
            </Row>
          </Column>
        ))}
      </Content>
      <span>
        &copy; 2011-2025 Vorne Industries. All Rights Reserved |{" "}
        <FooterLink url="/privacy/">Privacy Policy</FooterLink> |{" "}
        <FooterLink url="/cookies/">Cookie Policy</FooterLink>
      </span>

      <CopyScapeButton url="/reusing-content/" />
    </Root>
  );
}

export default FooterBase;
